export default "__VITE_ASSET__DsUzkZxE__"